import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { LocaleProvider } from 'antd';
import { Provider } from 'react-redux';
import * as firebase from 'firebase';
import enUS from 'antd/lib/locale-provider/en_US';
import React, { Component } from 'react';
import thunk from 'redux-thunk';

import BlogCreate from './views/blogs/Create';
import MainContent from './views/main';
import ProductCreate from './views/products/Create';
import PromotionCreate from './views/promotions/Create';
import reducers from './reducers';
import Welcome from './views/welcome';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const store = createStoreWithMiddleware(reducers);

const AdminRoute = ({ component: Component, ...rest }) => {
    const auth = firebase.auth().currentUser;

    // console.log(auth);

    return (
        <Route {...rest} render={props => {
            if (auth && !auth.isAnonymous) {
                const updateProps = { ...props, auth: auth };
                return <Component {...updateProps} />;
            } else {
                return (
                    <Redirect to={{
                        pathname: '/welcome',
                        state: { from: props.location }
                    }} />
                );
            }
        }} />
    )
}

class App extends Component {

    constructor(props) {
        super(props);

        this.initializeFirebase();

        this.state = { authDidCheck: false };
    }

    componentWillMount() {
        firebase.auth().onAuthStateChanged((user) => {
            this.setState({
                authDidCheck: true
            });
        });
    }

    initializeFirebase() {
        var config = {
            apiKey: "AIzaSyCYH7a3jnj5L2mM71rkkWJBR5hvuBN4FcQ",
            authDomain: "cross-border-admin.firebaseapp.com",
            databaseURL: "https://cross-border-admin.firebaseio.com",
            projectId: "cross-border-admin",
            storageBucket: "cross-border-admin.appspot.com",
            messagingSenderId: "618563667946"
        };

        firebase.initializeApp(config);
    }

    render() {
        if (!this.state.authDidCheck) {
            return (<div></div>);
        }

        const { cookies } = this.props;

        return (
            <LocaleProvider locale={enUS}>
                <Provider store={store}>
                    <BrowserRouter>
                        <Switch>
                            <Route exact path="/welcome" component={Welcome} />

                            <AdminRoute exact path="/products/new" component={ProductCreate} />
                            <AdminRoute exact path="/products/:productId" component={ProductCreate} />

                            <AdminRoute exact path="/blogs/new" component={BlogCreate} />
                            <AdminRoute exact path="/blogs/:blogId" component={BlogCreate} />

                            <AdminRoute exact path="/orders/:uid/:orderId" component={MainContent} />

                            <AdminRoute exact path="/promotions/new" component={PromotionCreate} />
                            <AdminRoute exact path="/promotions/:promotionId" component={PromotionCreate} />

                            <AdminRoute exact path="/:page" component={MainContent} />
                            <AdminRoute exact path="/" component={MainContent} />
                        </Switch>
                    </BrowserRouter>
                </Provider>
            </LocaleProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js